<template>
    <div class="card">
        <div class="card-header text-center">
            {{ title }}
        </div>
        <div class="card-body">
             <ul id="">
                <li v-for="letter in infLetters" :key="letter.name">
                    <a :href="'#'+ letter.name" class="">{{ letter.name }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "InfLetterCard",
    props: ["title", "infLetters"],
    components: {
        
    },
    methods:{

    }
};
</script>